import React, { useEffect } from 'react';

import { useSecrets } from 'context/SecretsProvider/SecretsProvider';
import { initialiseChart } from 'features/Health/components/FrameHealthChart/utils/initialiseChart';
import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';

type FrameHealthChartProps = {
  chartId: string;
  chartData: FrameHealthDimension[];
  frameHealthDimension: string;
};

const FrameHealthChart = ({ chartId, chartData, frameHealthDimension }: FrameHealthChartProps) => {
  const { getSecrets } = useSecrets();
  const { amchartsLicenseKey } = getSecrets();

  useEffect(() => {
    const root = initialiseChart(chartId, chartData, frameHealthDimension, amchartsLicenseKey);

    return () => {
      root.dispose();
    };
  }, [chartData]);

  return (
    <div data-testid="frameHealthChart" id={chartId} style={{ width: '100%', height: '27em' }} />
  );
};

export default FrameHealthChart;
